import { type FocusEventHandler } from "react";
import { isInviewAll } from "./is-inview-all";

// React Hook Form でバリデーションエラー発生時に、エラー発生した Element にスクロールするためのメソッド
// Ref. https://zenn.dev/daisuke7924/articles/5839e0094c5fdf

export const scrollOnFocus: FocusEventHandler<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement> = (event) => {
  try {
    const element = event.currentTarget;
    // elementをタップしてフォーカスしたときはスクロールしない
    // biome-ignore lint/style/useBlockStatements :[AUTOMATICALLY-INSERTED] Block statements are preferred in this position.
    if (isInviewAll(element)) return;

    element.scrollIntoView({
      block: "center",
      behavior: "auto",
    });
    // biome-ignore lint/suspicious/noEmptyBlockStatements :[AUTOMATICALLY-INSERTED] Unexpected empty block.
  } catch {}
};
